import React, { Component } from "react";

/**
 * /health/frontend — shows stamped build fingerprint.
 * Also available as static HTML at the same path (DirectoryIndex) without React.
 */
class FrontendHealthPage extends Component {
  state = {
    info: typeof window !== "undefined" ? window.__TPG_BUILD__ || null : null,
    error: null,
    loading: true,
  };

  componentDidMount() {
    if (this.state.info) {
      this.setState({ loading: false });
      return;
    }
    fetch("/build-info.json?t=" + Date.now(), { cache: "no-store" })
      .then((r) => {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then((info) => this.setState({ info, loading: false }))
      .catch((e) =>
        this.setState({
          loading: false,
          error: e.message || "Failed to load build-info.json",
        })
      );
  }

  render() {
    const { info, error, loading } = this.state;
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#111",
          color: "#eee",
          fontFamily: "system-ui, sans-serif",
          padding: "2rem",
        }}
      >
        <h1>TPG Frontend Health</h1>
        <p>Deploy fingerprint for Pentecost+ SPA DocumentRoot.</p>
        {loading ? <p>Loading…</p> : null}
        {error ? (
          <p style={{ color: "#f66" }}>
            {error} — if you see this in production, the SPA build was not
            stamped or DocumentRoot is stale.
          </p>
        ) : null}
        {info ? (
          <pre
            style={{
              background: "#222",
              padding: "1rem",
              borderRadius: 8,
              overflow: "auto",
            }}
          >
            {JSON.stringify(info, null, 2)}
          </pre>
        ) : null}
        <p>
          <a href="/build-info.json" style={{ color: "#8cf" }}>
            /build-info.json
          </a>
        </p>
      </div>
    );
  }
}

export default FrontendHealthPage;
